<template>
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%; background-color:#fff;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">
          办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea"
                       placeholder="请输入审批说明"/>
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交
          </van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames">
      <van-field v-model="inputForm.systemName" label="系统名称" label-width="110px" readonly input-align="left" :border="false"
                 autosize rows="1" type="textarea"/>
      <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.attachList1.length > 0">
        <p style="color: #AAA">管理系统组织架构设置一览表</p>
        <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList1" :key="index"
           @click="$viewAttach(file)">{{ file.name }}</p>
      </div>
      <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.attachList2.length > 0">
        <p style="color: #AAA">管理系统通用角色权限一览表</p>
        <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList2" :key="index"
           @click="$viewAttach(file)">{{ file.name }}</p>
      </div>
      <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.attachList3.length > 0">
        <p style="color: #AAA">管理系统通用用户角色一览表</p>
        <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList3" :key="index"
           @click="$viewAttach(file)">{{ file.name }}</p>
      </div>
      <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.attachList4.length > 0">
        <p style="color: #AAA">管理系统专用角色权限一览表</p>
        <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList4" :key="index"
           @click="$viewAttach(file)">{{ file.name }}</p>
      </div>
      <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.attachList5.length > 0">
        <p style="color: #AAA">管理系统专用用户角色一览表</p>
        <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList5" :key="index"
           @click="$viewAttach(file)">{{ file.name }}</p>
      </div>
      <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.attachList6.length > 0">
        <p style="color: #AAA">管理系统数据权限一览表</p>
        <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList6" :key="index"
           @click="$viewAttach(file)">{{ file.name }}</p>
      </div>
      <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.attachList7.length > 0">
        <p style="color: #AAA">管理系统审批流程角色权限一览表</p>
        <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList7" :key="index"
           @click="$viewAttach(file)">{{ file.name }}</p>
      </div>
      <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.attachList8.length > 0">
        <p style="color: #AAA">管理系统审批流程用户角色一览表</p>
        <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList8" :key="index"
           @click="$viewAttach(file)">{{ file.name }}</p>
      </div>
      <van-field v-model="inputForm.createByName" label="制单人" label-width="110px" readonly input-align="left"
                 :border="false" autosize rows="1" type="textarea"/>
      <van-field v-model="inputForm.createDate" label="制单日期" label-width="110px" readonly input-align="left"
                 :border="false" autosize rows="1" type="textarea"/>


    </van-collapse>
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import processRecord from "@/components/processRecord/processRecord.vue";
import TaskService from "@/api/flowable/TaskService";
import ProcessService from "@/api/flowable/ProcessService";
import QueryInfoService from "@/api/system/queryInfoService";

export default {
  name: "CmsIcmStandard",
  data() {
    return {
      activeNames: ['1', '2', '3'],
      isshow: false,
      radio: '',
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type: '',
      inputForm: {
        attachList: [],
        isDoTask: false,
        isLastTask: false,
      },
      flowTable: 'cms_icm_standard'
    }
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.$flow.queryById(id, '/erp/cms/icm/cmsIcmStandard/queryById').then(({data}) => {
        this.inputForm = data
        this.inputForm.createDate = data.createDate.slice(0, 10)
        if (!data.attachIds1) {
          this.inputForm.attachList1 = []
        }
        if (!data.attachIds2) {
          this.inputForm.attachList2 = []
        }
        if (!data.attachIds3) {
          this.inputForm.attachList3 = []
        }
        if (!data.attachIds4) {
          this.inputForm.attachList4 = []
        }
        if (!data.attachIds5) {
          this.inputForm.attachList5 = []
        }
        if (!data.attachIds6) {
          this.inputForm.attachList6 = []
        }
        if (!data.attachIds7) {
          this.inputForm.attachList7 = []
        }
        if (!data.attachIds8) {
          this.inputForm.attachList8 = []
        }
      }).catch(e => {
        console.log(e)
      })
    },
    getDict(dicts){
      new QueryInfoService().getDictMap().then(({data}) => {
        dicts.map(([dictType, formField]) => {
          this.$set(this.inputForm, `${formField}Label`, data[dictType].find(item=>item.value==this.inputForm[formField]).label);
        });
      }).catch(e => {
        console.log(e)
      })
    },
    close() {
      if (this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        // vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask ? '_flow_approval' : '_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          let form = {
            id: _this.inputForm.id,
            flowType: _this.inputForm.isLastTask ? 4 : 2,
            formKey: _this.formKey,
            flowTable: _this.flowTable
          }
          // _this.inputForm.flowType = _this.inputForm.isLastTask?4:2;
          _this.$flow.startFlow(form, '/cms/flow/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          // _this.inputForm.flowType = 3;
          let form = {
            id: _this.inputForm.id,
            flowType: 3,
            formKey: _this.formKey,
            flowTable: _this.flowTable
          }
          _this.$flow.startFlow(form, '/cms/flow/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    formatter(value) {
      return Number(value).toFixed(2)
    },
  }
}
</script>

<style scoped>

</style>
